import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { type DocumentReleaseSummary } from "~/api/types";
import { Card } from "~/atoms/card";
import { formatDate } from "~/helpers/date";
import { PublishReportProgress } from "./PublishReportProgress";

interface Props {
  data: DocumentReleaseSummary;
}

const PublishReportCard = ({ data }: Props) => {
  const { t } = useTranslation();
  const adoptedAt = formatDate(data.adoptedAt);

  return (
    <Card className="h-fit w-48 shrink-0 gap-2 p-2">
      <div className="h-14">
        <Link
          to={`/documents/${data.document.id}?releaseId=${data.id}&tab=anchoring`}
        >
          <div
            className="hover:text-primary line-clamp-2"
            title={data.artifact.title}
          >
            {data.artifact.title}
          </div>
        </Link>
        <div className="text-muted-foreground truncate text-xs">
          {data.document.category.title}
        </div>
      </div>
      <PublishReportProgress
        releaseId={data.id}
        totalCount={data.readers.totalCount}
        openedCount={data.readers.openedCount}
        readCount={data.readers.readCount}
        canSeeDetails
      />
      <div className="text-muted-foreground text-sm">
        {t(($) => $.commons.document.adopted)} {adoptedAt}
      </div>
    </Card>
  );
};

export default PublishReportCard;
